module.exports = __webpack_public_path__ + "static/media/NP.f6ee4ce9.svg";